// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('.ignite-btn-solid');
//   if (!btn || btn.classList.contains('is-disabled')) return;

//   const variantId = btn.dataset.variantId;
//   if (!variantId) return;

//   btn.classList.add('loading');

//   try {
//     /* 1️⃣ Add item */
//     const addRes = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1,
//         sections: ['cart-drawer', 'cart-icon-bubble']
//       })
//     });

//     const addData = await addRes.json();
//     if (!addRes.ok) throw addData;

//     /* 2️⃣ Fetch updated sections */
//     const sectionsRes = await fetch(
//       '/?sections=cart-drawer,cart-icon-bubble'
//     );
//     const sectionsHTML = await sectionsRes.json();

//     /* 3️⃣ Replace cart drawer HTML */
//     const drawer = document.querySelector('#CartDrawer');
//     if (drawer && sectionsHTML['cart-drawer']) {
//       drawer.innerHTML = sectionsHTML['cart-drawer'];
//       drawer.classList.add('is-open');
//       document.body.classList.add('cart-open');
//     }

//     /* 4️⃣ Update cart count */
//     const cartBubble = document.querySelector('#CartCount');
//     if (cartBubble && sectionsHTML['cart-icon-bubble']) {
//       cartBubble.innerHTML = sectionsHTML['cart-icon-bubble'];
//     }

//   } catch (err) {
//     console.error('Cart error:', err);
//   } finally {
//     btn.classList.remove('loading');
//   }
// });
document.addEventListener('click', (e) => {
  const customBtn = e.target.closest('.ignite-btn-solid');
  if (!customBtn || customBtn.classList.contains('is-disabled')) return;

  const productCard = customBtn.closest('.product-card');
  if (!productCard) return;

  const igniteBtn = productCard.querySelector('.card__hover-button');
  if (!igniteBtn) {
    console.warn('Ignite add-to-cart button not found');
    return;
  }

  igniteBtn.click();
});